angular.module("kareo.ui.shared.directives.analytics", [
  "kareo.ui.shared.modules.analytics"
])

.directive 'trackClick', ['WebTracking', (WebTracking) ->
  restrict: 'AEC',
  scope: {
    trackProperties: '=?',
    trackClick: '@'
  },
  link: (scope, element, attr) ->
    element.bind('click', ->
      scope.$apply ->
        WebTracking.track(scope.trackClick, scope.trackProperties)
    )
]

.directive 'trackLink', ['WebTracking', (WebTracking) ->
  restrict: 'AEC',
  scope: {
    trackProperties: '=?',
    trackLink: '@'
  },
  link: (scope, element, attr) ->
    WebTracking.trackLink(element, scope.trackLink, scope.trackProperties)
]

.directive 'trackPage', ['WebTracking', (WebTracking) ->
  restrict: 'AEC',
  scope: {
    trackProperties: '=?',
    trackPage: '@'
  },
  link: (scope, element, attr) ->
    WebTracking.track(scope.trackPage, scope.trackProperties)
]